import { render, staticRenderFns } from "./ver_contacto.vue?vue&type=template&id=61978dcb&scoped=true"
import script from "./ver_contacto.vue?vue&type=script&lang=js"
export * from "./ver_contacto.vue?vue&type=script&lang=js"
import style0 from "./ver_contacto.vue?vue&type=style&index=0&id=61978dcb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61978dcb",
  null
  
)

export default component.exports